module.exports = __webpack_public_path__ + "img/truth.775c9d51.png";